var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4758 8.88387L7.89041 6.15378H5.2968V4.3829C5.2968 3.63582 5.65845 2.90718 6.82009 2.90718H8V0.582904C8 0.582904 6.92968 0.398438 5.90685 0.398438C3.76986 0.398438 2.37443 1.7063 2.37443 4.073V6.15378H0V8.88387H2.37443V15.4841C2.85114 15.5597 3.33881 15.5984 3.83562 15.5984C4.33242 15.5984 4.82009 15.5597 5.2968 15.4841V8.88387H7.4758Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.88b72101be3731bec892a4abfbe04cc5.svg";
export { ForwardRef as ReactComponent };